export const stringForAvatar = (name?: string, count = 2): string => {
  if (!name) {
    return ''
  }

  return name
    .trim()
    .split(' ')
    .map((word) => word.charAt(0))
    .map((letter) => letter.toUpperCase())
    .slice(0, count)
    .join('')
}
